import React from 'react';
import styles from './DataProviderSelector.module.scss';

export default function OpenBankingServiceProviderPlaceholder(props) {
  const { dataProvider: { logo, name } } = props;
  return (
    <div>
      <div>Open Banking OAuth Placeholder</div>
      <img alt={name} className={styles.logo} src={logo} width="80" />
      <div>This will eventually be replaced with a redirect to the banks OAuth login screen</div>
      <div>
        You would have been redirected to the&nbsp;
        { name }
        &nbsp;OAuth login form.
      </div>
    </div>
  );
}
